import React, { useEffect, useState } from 'react';
import GoBackButton from '../content/common/GoBackButton';
import CommunicationPreferencesButton from '../content/common/reusables/CommunicationPreferencesButton';
import { ImageBackground } from 'react-native';
import { useOverviewDispatch, useOverviewState } from '../../context/overview';
import { useEnvState } from '../../context/env';
import { useAuthState, useAuthDispatch } from '../../context/auth';
import { useCategoriesState } from '../../context/categories';
import { useTheme, Text, Box, Pressable, HStack, FlatList, useBreakpointValue } from 'native-base';
import { getImage } from '../utils/images';
import { toggleUserDMOption } from '../utils/helpers';
import Notification from './Notification';
import { DEVICE_HEIGHT, LANGUAGES, NOTIFICATIONS_TABS } from '../Constants';
import Filter from './Filter';
import NotificationTabs from './NotificationTabs';
const NotificationScreen = props => {
  var _props$route;
  const theme = useTheme(),
    {
      colors
    } = theme;
  const carrotsImage = {
    uri: getImage('carrots')
  };
  const overviewState = useOverviewState();
  const {
    notifications,
    messages,
    unreadActivityCount,
    unreadMessagesCount
  } = overviewState;
  const overviewDispatch = useOverviewDispatch();
  const envState = useEnvState();
  const authState = useAuthState();
  const authDispatch = useAuthDispatch();
  const categoriesState = useCategoriesState();
  const [displayedActivity, setDisplayedActivity] = useState(notifications.activity);
  const [selected, setSelected] = useState(((_props$route = props.route) === null || _props$route === void 0 || (_props$route = _props$route.params) === null || _props$route === void 0 ? void 0 : _props$route.selected) || 'Activity');
  const [selectedFilter, setSelectedFilter] = useState('All');
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const authUserName = `${envState.discourse_api_username_prefix}.${authState.platform_user_id}`;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    loadContents();
  }, [envState.base_url, authUserName, authState.api_key, selected, selectedFilter]);
  useEffect(() => {
    if (props.dispatchForumAuth) {
      toggleUserDMOption({
        authState,
        envState,
        authDispatch
      });
    }
  }, [props.dispatchForumAuth]);
  const loadContents = () => {
    if (envState.base_url && authUserName && authState.api_key && selected && selectedFilter) {
      getDisplayData();
      setRenderItem();
    }
  };
  const getDisplayData = async () => {
    const allowedTabNames = NOTIFICATIONS_TABS.map(tab => tab.name);
    if (!allowedTabNames.includes(selected)) {
      throw new Error('Invalid selected value');
    }
    if (selected === NOTIFICATIONS_TABS[0].name && selectedFilter) {
      let filteredNotifications = overviewState.notifications.activity.filter(n => {
        if (selectedFilter.toLowerCase() === 'read') return n.read;
        if (selectedFilter.toLowerCase() === 'unread') return !n.read;
        return n;
      });
      setDisplayedActivity(filteredNotifications);
      return filteredNotifications;
    }
  };
  const setRenderItem = () => {
    return ({
      item: notification
    }) => /*#__PURE__*/React.createElement(Notification, {
      key: notification.id,
      notification: notification,
      navigation: props.navigation,
      selected: selected,
      loadContents: loadContents
    });
  };
  const renderItem = setRenderItem();

  // container width
  const width = useBreakpointValue({
    base: '100vw',
    lg: '70vw'
  });

  // flatlist height
  const height = useBreakpointValue({
    base: DEVICE_HEIGHT,
    lg: DEVICE_HEIGHT * 0.7
  });

  // flatlist margin bottom
  const marginBottom = useBreakpointValue({
    base: '12vh',
    lg: 0
  });
  return /*#__PURE__*/React.createElement(Box, {
    alignSelf: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    w: width,
    h: "16vh",
    mb: "16"
  }, /*#__PURE__*/React.createElement(ImageBackground, {
    source: carrotsImage,
    imageStyle: {
      opacity: 0.5
    },
    style: {
      height: '100%',
      borderTopRightRadius: 10,
      borderTopLeftRadius: 10
    }
  }, /*#__PURE__*/React.createElement(Box, {
    pt: "4",
    pl: "4"
  }, /*#__PURE__*/React.createElement(GoBackButton, {
    navigation: props.navigation
  })), /*#__PURE__*/React.createElement(Text, {
    fontSize: '2xl',
    color: colors.searchResult.header,
    fontWeight: "bold",
    pl: "4",
    pb: "4",
    style: {
      marginTop: 'auto'
    }
  }, "Inbox")), /*#__PURE__*/React.createElement(NotificationTabs, {
    selected: selected,
    setSelected: setSelected
  }), /*#__PURE__*/React.createElement(Filter, {
    selected: selected // 'Activity', 'Messages', 'Sent'
    ,
    selectedFilter: selectedFilter // 'All', 'Read', 'Unread'
    ,
    setSelectedFilter: setSelectedFilter,
    isFilterOpen: isFilterOpen,
    setIsFilterOpen: setIsFilterOpen
  })), /*#__PURE__*/React.createElement(Box, {
    w: width,
    h: height,
    mb: marginBottom
  }, /*#__PURE__*/React.createElement(HStack, {
    justifyContent: 'center'
  }, selected === 'Messages' && /*#__PURE__*/React.createElement(Pressable, {
    bg: colors.purple.primary,
    borderRadius: "50px",
    width: "300px",
    mr: 4,
    onPress: () => props.navigation.navigate('PrivateMessage', {})
  }, /*#__PURE__*/React.createElement(Text, {
    alignSelf: "center",
    color: colors.white
  }, LANGUAGES.PLACEHOLDERS.NEW_TOPIC)), /*#__PURE__*/React.createElement(CommunicationPreferencesButton, {
    toggleProfileModal: props.toggleProfileModal
  })), selected === 'Activity' ? !(displayedActivity !== null && displayedActivity !== void 0 && displayedActivity.length) ? /*#__PURE__*/React.createElement(Text, {
    alignSelf: "center"
  }, "You're up to date!") : /*#__PURE__*/React.createElement(FlatList, {
    data: displayedActivity,
    renderItem: renderItem,
    keyExtractor: notification => notification.id.toString()
  }) : null, selected === 'Messages' ? !(messages !== null && messages !== void 0 && messages.length) ? /*#__PURE__*/React.createElement(Text, {
    alignSelf: "center"
  }, "You're up to date!") : /*#__PURE__*/React.createElement(FlatList, {
    data: messages,
    renderItem: renderItem,
    keyExtractor: message => message.id.toString()
  }) : null));
};
export default NotificationScreen;
//# sourceMappingURL=NotificationScreen.js.map